/**
 * Application-wide constants and configuration
 */

// Default company name — used as fallback when CMS data is unavailable
export const COMPANY_NAME = 'MFJ Associates';

// Strapi API base URL is resolved at runtime on the server via getStrapiUrl() in server-config.ts

// API Endpoints
export const API_ENDPOINTS = {
  global: '/api/global?populate[logoLight]=*&populate[logoDark]=*&populate[faviconLight]=*&populate[faviconDark]=*&populate[socialMedia]=*&populate[menuItems]=*&populate[address]=*',
  services: '/api/service',
  stats: '/api/stats-page',
  profiles: '/api/profiles',
  projects: '/api/projects',
  links: '/api/links',
} as const;

// Fetch Configuration
export const DEFAULT_FETCH_OPTIONS: RequestInit = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
  cache: 'no-store', // Always fetch fresh data
};

// Cache Tags for ISR revalidation (used in fetch 'next.tags' option)
export const CACHE_TAGS = {
  global: 'strapi-global',
  services: 'strapi-services',
  stats: 'strapi-stats',
  profiles: 'strapi-profiles',
  projects: 'strapi-projects',
  links: 'strapi-links',
  tos: 'strapi-tos',
  privacy: 'strapi-privacy',
  userData: 'strapi-user-data',
} as const;
